import { styled } from "@mui/material";
import starIcon from "../../assets/icons/icon_star.svg";

export const NavigationInstructionsRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "2rem",
  padding: 0,
  height: "100%",
  boxSizing: "border-box",
  [theme.breakpoints.down("md")]: {
    gap: 0,
    padding: 0,
    "@media (orientation: landscape)": {
      gap: "2rem",
      flexDirection: "row",
      paddingTop: 0,
    },
  },
  [theme.breakpoints.up("xl")]: {
    "@media (orientation: landscape)": {
      paddingTop: 0,
    },
  },
  "& .instructions__content": {
    padding: "015vw 0 15vw",
    [theme.breakpoints.down("xl")]: {
      padding: "0 10vw",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0 10vw 0",
      "@media (orientation: landscape)": {
        paddingRight: "2vw",
        alignItems: "flex-end",
      },
    },
  },
  "& .instructions__image": {
    opacity: 0,
    animation: "fadeInScale 2s 2s ease-out forwards",
    [theme.breakpoints.up("md")]: {
      animation: "fadeInSlide 2.5s 2s ease-out forwards",
    },
  },
  "& .instructions__loading__dot": {
    "&:nth-of-type(1)": {
      animation: "opacityDots1 3s infinite forwards ease",
    },
    "&:nth-of-type(2)": {
      animation: "opacityDots2 3s infinite forwards ease",
    },
    "&:nth-of-type(3)": {
      animation: "opacityDots3 3s infinite forwards ease",
    },
  },
  "& .instructions__title": {
    "& span": {
      fontFamily: "inherit",
      display: "block",
      opacity: 0,
      animation: "fadeInSlide 2.5s 1s ease-out forwards",
      "&:nth-of-type(2)": {
        marginTop: "-6rem",
        marginLeft: "12rem",
        textTransform: "uppercase",
        animationDuration: "3s",
        animationDelay: "1.5s",
        [theme.breakpoints.down("lg")]: {
          marginTop: "-3.2rem",
        },
        [theme.breakpoints.down("md")]: {
          marginTop: "-2.4rem",
          marginLeft: "6rem",
        },
        [theme.breakpoints.down("sm")]: {
          marginLeft: 0,
        },
      },
    },
  },
  "& .instructions__details": {
    opacity: 0,
    animation: "fadeIn 2.5s 2s ease-out forwards",
  },
  "@keyframes fadeIn": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    },
  },
  "@keyframes fadeInSlide": {
    "0%": {
      opacity: 0,
      transform: "translateX(-3rem)",
    },
    "100%": {
      opacity: 1,
      transform: "translateX(0)",
    },
  },
  "@keyframes fadeInScale": {
    "0%": {
      opacity: 0,
      transform: "scale(1.2)",
    },
    "100%": {
      opacity: 1,
      transform: "scale(1)",
    },
  },
  "@keyframes opacityDots1": {
    "0%": {
      opacity: 1,
    },
    "66%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
  "@keyframes opacityDots2": {
    "0%": {
      opacity: 0,
    },
    "33%": {
      opacity: 1,
    },
    "66%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
  "@keyframes opacityDots3": {
    "0%": {
      opacity: 0,
    },
    "33%": {
      opacity: 0,
    },
    "66%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
}));

export const NavigationInstructionsItem = styled("div")(({ theme }) => ({
  zIndex: 1,
  maxHeight: "fit-content",
  width: "auto",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: "100%",
  gap: "2rem",
  // color: "#000",
  color: "#071A3D",
  textAlign: "center",
  minWidth: "13vw",
  fontSize: "1.2rem",
  padding: "5rem",
  // borderLeft: "1px solid #fa0",
  borderLeft: "1px solid #071A3D",
  "&:nth-of-type(1)": {
    border: "none",
  },
  [theme.breakpoints.down("xl")]: {
    padding: "2.4rem",
  },
  [theme.breakpoints.down("md")]: {
    padding: "1.6rem",
    "@media (orientation: landscape)": {
      fontSize: "1.2rem",
      // borderTop: "1px solid #fa0",
      borderTop: "1px solid #071A3D",
      "&:nth-of-type(1)": {
        // borderLeft: "1px solid #fa0",
        borderLeft: "1px solid #071A3D",
        borderTop: "none",
      },
    },
  },
  [theme.breakpoints.down("sm")]: {
    // borderTop: "1px solid #fa0",
    borderTop: "1px solid #071A3D",
    borderLeft: "none",
    padding: "1.2rem",
  },
  "@media only screen and (min-width: 2560px) and (min-height: 1440px)": {
    gap: "4rem",
  },
}));
